import i18next, { TOptions } from "i18next";
import { createContext, useContext } from "react";

import initialise from "./initialisation";
import resources, { TranslationKey } from "./resources";

export type TranslateFunction = (key: TranslationKey, options?: TOptions) => string;

const DEFAULT_LANGUAGE = "en-GB";

initialise([], resources).catch(async (error) => {
  console.error("Error during initialisation of i18next", error);
  process?.exit(1);
});

export const i18nContext = createContext(DEFAULT_LANGUAGE);

export const useLanguage = () => useContext(i18nContext);

export const useTranslate = (): TranslateFunction => {
  const lng = useContext(i18nContext);
  return (key, options) => i18next.t(key, { lng, ...options });
};
